import { z } from "zod";

const CashDetailsSchema = z
  .object({
    img: z.string().optional().nullable(),
    reference: z.string(),
  })
  .transform((api) => ({
    image: api.img,
    reference: api.reference,
  }));

type CashDetails = z.infer<typeof CashDetailsSchema>;

export { CashDetailsSchema, type CashDetails };
